import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Seo from '../components/Seo';
import { Newspaper } from 'lucide-react';
import HeaderSection from './HeaderSection';
import Footer from './Footer';
import ScrollToTop from './ScrollToTop';

const Blog = () => {
  return (
    <>
      <Seo
        title="TotoWala Blog - Coming Soon"
        description="The TotoWala blog is coming soon. Stay tuned for driver tips, rider guides, and news about India's premier zero-commission ride platform."
        canonical="/blog"
      />
      <div className="min-h-screen bg-white dark:bg-dark-bg flex flex-col">
        <HeaderSection />

        <main className="flex-1 flex flex-col items-center justify-center bg-surface-alt dark:bg-dark-surface-alt py-24 px-4">
          <div className="max-w-[760px] mx-auto text-center flex flex-col items-center">
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5 }}
              className="w-20 h-20 rounded-control bg-white dark:bg-dark-surface border border-line dark:border-dark-line flex items-center justify-center mb-8 shadow-sm"
            >
              <Newspaper size={32} className="text-primary" />
            </motion.div>
            
            <motion.h1
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.45, delay: 0.1 }}
              className="font-display text-4xl sm:text-5xl font-semibold leading-tight text-ink dark:text-dark-ink mb-4"
            >
              Stories & Insights
            </motion.h1>
            
            <motion.p
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: 0.2 }}
              className="text-base sm:text-lg text-ink-soft dark:text-dark-ink-soft leading-relaxed max-w-lg mx-auto mb-8"
            >
              We're working on something exciting! Our blog is coming soon with tips, guides, and the latest news from TotoWala.
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: 0.3 }}
              className="flex items-center justify-center gap-4 flex-wrap"
            >
              <Link
                to="/"
                className="inline-flex items-center justify-center px-6 py-3 rounded-full text-sm font-semibold text-white bg-primary hover:bg-primary-dark transition-colors"
              >
                Back to Home
              </Link>
              <Link
                to="/contact"
                className="inline-flex items-center justify-center px-6 py-3 rounded-full text-sm font-semibold text-ink dark:text-dark-ink border border-line dark:border-dark-line hover:border-primary transition-colors bg-white dark:bg-dark-surface"
              >
                Contact Us
              </Link>
            </motion.div>
          </div>
        </main>

        <Footer />
        <ScrollToTop />
      </div>
    </>
  );
};

export default Blog;
